import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const insightsPortalCollectionsAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.InsightsPortalCollections, Permission.InsightsPortalCollectionsTemp],
}
